import { useContext, useEffect, useState } from 'react'
import PageContext from '../../global_state/context/PageContext'

import { PageType } from 'types/PageI'
import Title from 'components/Title'
import Loader from 'components/Loader'

import SCSS from 'assets/scss/CreateOnlineAccount.module.scss'
import FormSCSS from 'assets/scss/Form.module.scss'
import AppSCSS from 'assets/scss/App.module.scss'

import content from 'languages/CreateOnlineAccount.json'
import { CreateOnlineAccountService } from 'services/user_services/CreateOnlineAccountService'
import UserContext from 'global_state/context/UserContext'


function CreateOnlineAccount() {

    const {page, dispatchPage}  = useContext(PageContext)
    const {user, dispatchUser} = useContext(UserContext)
    let language = page.settings.language

    
    const [loading, setLoading] = useState(false)
    const [new_user_email, setNewUserEmail] = useState('')
    const [online_account_response, setOnlineAccountResponse] = useState<any>()

    const handleSubmit = async (event) => {
        event.preventDefault()
        // console.log(event);
        setLoading(true)

        setOnlineAccountResponse(await CreateOnlineAccountService(new_user_email, language))
    }

    useEffect(() => {
        // console.log(online_account_response);
        setLoading(false)


        if (online_account_response === "item_email_required") {
            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "error",
                        message: online_account_response
                    }
                }
            })
            return 
        } 

        if (online_account_response === "email_not_found_error") {
            dispatchPage({type: "render", payload: {page: PageType.email_not_found}})
            return 
        } 

        
        if (online_account_response === "online_account_exist_error") {
            // console.log("account exist and is verified: did you forget your password");

            // dispatchPage({
            //     type: "add_notification",
            //     payload: {
            //         notification: {
            //             type: "warning",
            //             message: online_account_response
            //         }
            //     }
            // })

            dispatchPage({
                type: "render",
                payload: {
                  page: PageType.log_in_form,
                  props: {
                    from_page: PageType.create_online_account
                  }
                }
              })
            return 
        } 

        if ((typeof online_account_response === 'string') && online_account_response.includes("error")) {
            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "error",
                        message: online_account_response
                    }
                }
            })
            return 
        }

        if (online_account_response === "email_send" || online_account_response === "new_email_send") {
            dispatchUser({type: "update_user_email", payload: {email: new_user_email}})
            dispatchPage({type: "render", payload: {page: PageType.verify_email, props: {path: 'online'}}})
        } 
        
        
    }, [online_account_response])

    if (loading) {
        return (
            <Loader/>
        )
    }

    const renderAccountAlreadyVerifeid = () => {
        if (online_account_response !==  'online_account_exist') {
            return null
        }
        
        return (
            <div>
                <div>
                    {content[language].account_verified}
                </div>
                <button>
                    {content[language].button_forgotten_password}
                </button>
            </div>
        )
    }

    return (
        <div className={[SCSS.create_online_account, FormSCSS.form_wrapper].join(" ")}>
            <Title back_arrow={true} title={content[language].title} page={PageType.entrance}/>
            <form 
                className={FormSCSS.form} 
                onSubmit={(event) => {handleSubmit(event)}} >

                <div className={SCSS.info_text}>{content[language].text}</div>

                {renderAccountAlreadyVerifeid()}

                
                <label className={FormSCSS.label} htmlFor="email">
                    <input 
                        className={FormSCSS.input}
                        type="text" 
                        name='email'
                        id='email'
                        placeholder={content[language].email_placeholder}
                        value={new_user_email}
                        onChange={(e) => {setNewUserEmail(e.target.value.toLowerCase())}}/>
                </label>
                <button 
                    className={[AppSCSS.button, AppSCSS.red].join(" ")} 
                    type="submit">
                        {content[language].button_submit}</button>
            
            </form>

        </div>
    )
}

export default CreateOnlineAccount